import { backendClient } from "../../api/backend"
import {
  ENTREPRISES_SEARCH_REQUEST,
  ENTREPRISES_SEARCH_SUCCESS,
  ENTREPRISES_SEARCH_FAILURE,
  ENTREPRISES_FETCH_DETAIL_REQUEST,
  ENTREPRISES_FETCH_DETAIL_SUCCESS,
  ENTREPRISES_FETCH_DETAIL_FAILURE,
  ENTREPRISES_FETCH_COMPANY_REQUEST,
  ENTREPRISES_FETCH_COMPANY_SUCCESS,
  ENTREPRISES_FETCH_COMPANY_FAILURE,
  ENTREPRISES_FETCH_STATS_REQUEST,
  ENTREPRISES_FETCH_STATS_SUCCESS,
  ENTREPRISES_FETCH_STATS_FAILURE,
  ENTREPRISES_AUTOCOMPLETE_REQUEST,
  ENTREPRISES_AUTOCOMPLETE_SUCCESS,
  ENTREPRISES_AUTOCOMPLETE_FAILURE,
  ENTREPRISES_SET_FILTERS,
  ENTREPRISES_CLEAR_FILTERS,
  ENTREPRISES_SET_QUERY,
  ENTREPRISES_SET_PAGE,
  ENTREPRISES_RESET,
} from "./types"

export const searchLegalNotices = (params = {}) => async (dispatch, getState) => {
  const state = getState().entreprises
  const searchParams = {
    q: params.q !== undefined ? params.q : state.query,
    page: params.page ?? state.pagination.page,
    page_size: params.page_size ?? state.pagination.page_size,
    ...state.filters,
    ...(params.filters || {}),
  }

  dispatch({ type: ENTREPRISES_SEARCH_REQUEST })
  try {
    const data = await backendClient.searchLegalNotices(searchParams)
    dispatch({ type: ENTREPRISES_SEARCH_SUCCESS, payload: data })
    return data
  } catch (error) {
    dispatch({ type: ENTREPRISES_SEARCH_FAILURE, payload: error.message })
    throw error
  }
}

export const fetchAnnonceDetail = (annonceId) => async (dispatch) => {
  dispatch({ type: ENTREPRISES_FETCH_DETAIL_REQUEST })
  try {
    const data = await backendClient.getLegalNoticeDetail(annonceId)
    dispatch({ type: ENTREPRISES_FETCH_DETAIL_SUCCESS, payload: data })
    return data
  } catch (error) {
    dispatch({ type: ENTREPRISES_FETCH_DETAIL_FAILURE, payload: error.message })
    throw error
  }
}

export const fetchCompanyProfile = (rc, villeRc) => async (dispatch) => {
  dispatch({ type: ENTREPRISES_FETCH_COMPANY_REQUEST })
  try {
    const data = await backendClient.getCompanyProfile(rc, villeRc)
    dispatch({ type: ENTREPRISES_FETCH_COMPANY_SUCCESS, payload: data })
    return data
  } catch (error) {
    dispatch({ type: ENTREPRISES_FETCH_COMPANY_FAILURE, payload: error.message })
    throw error
  }
}

export const fetchEntreprisesStats = () => async (dispatch) => {
  dispatch({ type: ENTREPRISES_FETCH_STATS_REQUEST })
  try {
    const data = await backendClient.getLegalNoticesStats()
    dispatch({ type: ENTREPRISES_FETCH_STATS_SUCCESS, payload: data })
    return data
  } catch (error) {
    dispatch({ type: ENTREPRISES_FETCH_STATS_FAILURE, payload: error.message })
    throw error
  }
}

export const autocompleteLegalNotices = (q) => async (dispatch) => {
  dispatch({ type: ENTREPRISES_AUTOCOMPLETE_REQUEST })
  try {
    const data = await backendClient.autocompleteLegalNotices(q)
    dispatch({ type: ENTREPRISES_AUTOCOMPLETE_SUCCESS, payload: data })
    return data
  } catch (error) {
    dispatch({ type: ENTREPRISES_AUTOCOMPLETE_FAILURE, payload: error.message })
    throw error
  }
}

export const setEntreprisesFilters = (filters) => ({
  type: ENTREPRISES_SET_FILTERS,
  payload: filters,
})

export const clearEntreprisesFilters = () => ({
  type: ENTREPRISES_CLEAR_FILTERS,
})

export const setEntreprisesQuery = (query) => ({
  type: ENTREPRISES_SET_QUERY,
  payload: query,
})

export const setEntreprisesPage = (page) => ({
  type: ENTREPRISES_SET_PAGE,
  payload: page,
})

export const resetEntreprises = () => ({
  type: ENTREPRISES_RESET,
})
